import ReactDOM from "react-dom/client";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import "./index.css";

const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  // Pas de StrictMode : son double-montage d'effet en dev appellerait
  // kaplay() deux fois. KAPLAY n'est pas conçu pour être réinitialisé
  // (quit() ne réinitialise pas l'état global vérifié par kaplay()) —
  // se battre contre StrictMode ici serait un hack fragile pour un cas
  // que la lib elle-même dit ne pas supporter.
  root.render(<RouterProvider router={router} />);
}
